import { useToast } from '@/components/atoms/Toast';
import {
	dashboardRemoveListFailure,
	dashboardRemoveListRequest,
	dashboardRemoveListSuccess
} from '@/modules/dashboard/dashboardActions';
import type { List } from '@/modules/dashboard/dashboardTypes';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

export const useRemoveListMutation = () => {
	const { toast } = useToast();
	const dispatch = useDispatch();

	const mutate = useCallback(
		(list: List) => {
			try {
				dispatch(dashboardRemoveListRequest(list));
				dispatch(dashboardRemoveListSuccess(list));

				toast({
					title: `List ${list.name} has been removed`,
					variant: 'success'
				});
			} catch (error) {
				dispatch(dashboardRemoveListFailure(error as Error));

				toast({
					title: `Something went wrong with list ${list.name}`,
					variant: 'error'
				});
			}
		},
		[dispatch, toast]
	);

	return { mutate };
};
